import { useEffect } from 'react';
import ReactGA from 'react-ga4';

// Function to track page views with custom page titles (from your existing file)
export const trackPageView = (pageTitle, pagePath) => {
  ReactGA.send({
    hitType: 'page_view',
    page: pagePath,
    title: pageTitle,
  });
};

// Component to track a section with a custom page title
const TrackSectionPageView = ({ sectionName, pagePath }) => {
  useEffect(() => {
    // Send page view when component mounts
    trackPageView(sectionName, pagePath);
  }, [sectionName, pagePath]); // Re-run if props change

  return null; // No UI needed
};

export default TrackSectionPageView;